import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Angulartics2 } from 'angulartics2';
import { SeoService } from '../common/services/seo.service';

@Component({
  selector: 'app-unelte-page',
  templateUrl: './unelte-page.component.html',
  styleUrls: ['./unelte-page.component.scss']
})
export class UneltePageComponent implements OnInit {

  constructor(
    private titleService: Title,
    private angulartics2: Angulartics2,
    private meta: Meta,
    private seoService: SeoService,
  ) {
    this.seoService.setTitle('Unelte educative - Fun Bible');
    this.seoService.setDescription('Unelte și generatoare educative pentru activități și jocuri biblice pentru copii');
    this.meta.updateTag({ property: 'og:url', content: 'https://funbible.net/unelte/' });
    this.meta.updateTag({ property: 'og:image', content: 'https://funbible.net/assets/unelte.png' });
    const initialKeywords = ['unelte educative', 'generatoare', 'activitati copii', 'jocuri educative', 'generator cuvinte ascunse', 'unelte pentru copii'].join();
    this.meta.updateTag({property: 'keywords', content: initialKeywords});
    this.angulartics2.eventTrack.next({
      action: 'Unelte',
      properties: { category: 'pageView' },
    });
  }

  ngOnInit(): void {
  }

}
